
import HomeTitle from '@/comps/HomeTitle'
import { useState } from 'react'
import { cls } from 'reactutils'
import RuzhuIcon from '@/icons/home/ruzhu.svg'
import ShangpinIcon from '@/icons/home/shangpin.svg'
import JiaoyiIcon from '@/icons/home/jiaoyi.svg'
import ShoufahuoIcon from '@/icons/home/shoufahuo.svg'
import JSZFIcon from '@/icons/home/jszf.svg'
import SJCDIcon from '@/icons/home/sjcd.svg'
import MallServiceAdvantageBg from '@/images/cscec3b/home/mall-service-advantage.png'
import ArrowIcon from '@/icons/arrow.svg';
import ArrowIconL from '@/icons/arrow2.svg';
const list = [
  {
    title: '入驻',
    icon: <RuzhuIcon />,
    attrList: [
      {
        label: '入驻企业资质实时校验',
        children: ['便携提交申请', '严审资质信息', '多层认证评估']
      },
      {
        label: '用户实名认证安全交易',
        children: ['高效引导保障', '身份真实有效']
      },
      {
        label: '个性店铺满足商家诉求',
        children: ['多样需求定制', '店铺装修便捷', '专区设置清晰']
      }
    ]
  },
  {
    title: '商品',
    icon: <ShangpinIcon />,
    attrList: [
      {
        label: '交易规则适配多种品类',
        children: ['灵活计价方式', '多种交易方式', '多样采购流程']
      },
      {
        label: '权威网价获取商品价格',
        children: ['在线查询网价', '材料映射关联']
      },
      {
        label: '海量商品完备购物体验',
        children: ['丰富品牌入驻', '种类丰富鲜明']
      }
    ]
  },
  {
    title: '交易',
    icon: <JiaoyiIcon />,
    attrList: [
      {
        label: '一站式下单所见即所得',
        children: ['7*24小时响应', '计划流程管控', '宏观把控总量']
      },
      {
        label: '多样模式采购满足交易',
        children: ['双端采购模式', '货到付款/预付款', '先款后货/结算付款']
      },
      {
        label: '五星评价机制履约质量',
        children: ['采供双方评价', '月度红黑榜单', '持续监督检查']
      }
    ]
  },
  {
    title: '收发货',
    icon: <ShoufahuoIcon />,
    attrList: [
      {
        label: '自建物流体系匹配供需',
        children: ['海量运力随意选', '海量订单随意接']
      },
      {
        label: '追溯全程履约透明合规',
        children: ['自主研发地图', '全方位物流管控', '物资验收数字化']
      }
    ]
  },
  {
    title: '结算支付',
    icon: <JSZFIcon />,
    attrList: [
      {
        label: '多种支付模式聚合',
        children: ['融资支付', '在线支付', '线下支付']
      },
      {
        label: '结算支付开票真实在线',
        children: ['结算周期发起', '个性定制支付']
      },
      {
        label: '支付流程强管控早预警',
        children: ['风险管控机制']
      }
    ]
  },
  {
    title: '数据沉淀',
    icon: <SJCDIcon />,
    attrList: [
      {
        label: '完善指标全盘掌控数据',
        children: ['商城驾驶舱', '数字经营中心', '预警中心', '品控中心']
      },
    ]
  }
]

const showCount = 4;
export default function MallServiceAdvantage() {
  const [active, setActive] = useState(0)
  const leftClick = () => {
    if (active === 0) {
      return;
    }
    else {
      setActive(active - 1)
    }
  }
  const rightClick = () => {
    if (active === list.length - showCount) {
      return
    }
    else {
      setActive(active + 1)
    }
  }
  return <div className="advantage">
    <span className={cls('left-arrow', active === 0 && 'disabled')} onClick={leftClick}>
      <ArrowIconL style={{width: '20px', height: '20px'}} />
    </span>
    <span className={cls('right-arrow', active === list.length - showCount && 'disabled')} onClick={rightClick}>
      <ArrowIcon style={{width: '20px', height: '20px'}} />
    </span>
    <div className='content'>
      <HomeTitle title={'商城服务优势'} />
      {/* <div className='left-arrow'></div>
      <div className='right-arrow'></div> */}
      <div className="list">
        <div className='move-warpper'>
          {
            list.map((item, index) => <div className={cls("item", active === index && 'active')} key={index}>
              <span className='icon-box'>{item.icon}</span>
              <div className="title">{item.title}</div>
              {
                item.attrList.map((attr, i) => <div key={i}>
                  <div className="attr-name">{attr.label}</div>
                  <ul className='ul'>
                    {
                      attr.children.map((text, ti) => <li key={ti}>
                        {text}
                      </li>)
                    }
                  </ul>
                </div>)
              }
            </div>)
          }
        </div>
      </div>

    </div>
    <style jsx>{`
      .advantage {
        position: relative;
        padding-top: 40px;
        background-image: url(${MallServiceAdvantageBg});
        background-size: cover;
      }
      .content {
        width: 1230px;
        margin: 0 auto;
        padding-bottom: 92px;
        overflow: hidden;
        padding-left: 15px;
        padding-right: 15px;
      }
      .list {
        padding-top: 28px;
      }
      .left-arrow, .right-arrow {
        position: absolute;
        top: 386px;
        cursor: pointer;
        width: 48px;
        height: 48px;
        background: #fff;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 6px 6px 6px 0px rgba(154, 164, 169, 0.10);
      }
      .left-arrow.disabled, .right-arrow.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
      .left-arrow {
        left: calc(50% - 690px);
      }
      .right-arrow {
        right: calc(50% - 690px);
      }
      .item {
        width: 281px;
        height: 560px;
        padding: 32px 24px 42px 24px;
        border-radius: 16px;
        border: 2px solid #FFF;
        background: linear-gradient(180deg, #E6F3FF 0%, #FFF 15.05%);
        box-shadow: 0px 4px 60px 0px rgba(0, 28, 85, 0.04);
        position: relative;
      }
      .icon-box {
        position: absolute;
        top: 20px;
        right: 24px;
      }
      .title {
        color: #000;
        font-size: 30px;
        font-weight: 600;
        line-height: 40px;
        padding-bottom: 20px;
        border-bottom: 1px solid #E9EFF4;
      }
      .attr-name {
        color: rgba(25, 25, 25, 0.8);
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        margin-top: 30px;
        margin-bottom: 10px;
      }
      .ul li {
        list-style: disc;
        margin-left: 22px;
        color: #555555;
        margin-bottom: 8px;
      }
      .ul li:last-child {
        margin-bottom: 0;
      }
      .item:hover {
        transform: scale(1.1);
        background: linear-gradient(180deg, #42A3FF 0%, #018DD7 100%);
        transition: all 0.3s;
      }
      .item:hover .title {
        color: #fff;
      }
      .item:hover .attr-name {
        color: #fff;
      }
      .item:hover .ul li {
        color: #fff;
      }
      .move-warpper {
        display: flex;
        justify-content: space-between;
        width: ${list.length * 300}px;
        transform: translateX(-${active * 300}px);
        transition: transform 0.3s;
      }
    `}</style>
  </div>
}
